<template>
  <div>
    <form @submit="onSubmit">
      <div class="form-group">
        <p><em>Jäspi-valintatyökalu on tarkoitettu omakotitaloasujalle ja talviasuttavan mökin
          omistajalle suuntaa-antavaksi valintatyökaluksi. Työkalun avulla voit arvioida miten
          voisi pienentää talon ylläpidon kustannuksia. Siten voit arvioida vaihtoehtoja nykyisen
          lämmitysratkaisun täydentämiseksi tai korvaamiseksi.</em></p>
        <p><em>Lämmitysratkaisun valintaan liittyy aina useita talokohtaisia tekijöitä,
          joista kannattaa keskustella Jäspin jälleenmyyjän kanssa.</em></p>
        <p><em>Aloitetaan.</em></p>
        <h4>Talon asuinpinta-ala</h4>
        <input id="jst_area"
              type="number"
              v-model="form.area"
              required
              placeholder="125"
              min="0"
              max="100000"><span>m&sup2;</span>
      </div>
      <radio-group v-model="form.heating.value"
                  groupName="heating"
                  label="Valitse lämmityksen tyyppi"
                  :options="form.heating.options" />
      <button type="submit">Jatka</button>
    </form>
  </div>
</template>
<script>
export default {
  props: [
    'formData',
  ],
  data() {
    const fields = {
      area: '',
      heating: {
        value: 'default',
        options: [
          { text: 'Öljylämmitys', value: 'oil' },
          { text: 'Sähkölämmitys', value: 'electric' },
          { text: 'Puulämmitys', value: 'wood' },
          { text: 'Maalämpö', value: 'geothermal' },
          { text: 'Kaukolämpö', value: 'district' },
        ],
      },
    };
    const form = { ...fields, ...this.formData };
    return {
      form,
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$nextTick(() => {
        this.$emit('submitForm', this.form);
      });
    },
  },
};
</script>
<style lang="scss">
  form input::placeholder {
    color: lightgray !important;
  }
  #jst_area {
    display: inline-block;
    max-width: 10rem;
    margin-right: 1rem;
  }
</style>
